import { useEffect, useState } from "react";

export const usePageTransition = () => {
  const [transition, setTransition] = useState(true);
  useEffect(() => {
    setTransition(true);
    setTimeout(() => {
      setTransition(false);
    }, 300);
  }, []);
  return transition;
};
